<template>
  <md-toolbar class="md-dense">
    <div class="md-toolbar-section-start">
      <span>{{ L($route.name) | upper }}</span>
      <span
        v-if="$config.service.platform === 'azure'"
        style="color: red; flex-shrink: 0; margin-left: 25px"
      >
        * MS Azure 측 비용 데이터 적재 장애 조치 중에 있어서 빌링 데이터 제공이
        한시적으로 중단됩니다. 빠른 시일 내에 복구하도록 하겠습니다.
      </span>
    </div>
    <div class="md-toolbar-section-end">
      <slot />
      <md-checkbox
        v-if="
          (showCreditFilter &&
            !$config.feature.creditKind &&
            $config.service.platform !== 'azure') ||
          showApplyDiscount
        "
        v-model="applyDiscount"
        class="md-primary apply-discount md-small-size-100 md-xsmall-size-100"
        >{{ L('applyDiscount') }}</md-checkbox
      >
      <md-checkbox
        v-if="
          (showCreditFilter &&
            !$config.feature.creditKind &&
            $config.service.platform === 'azure') ||
          showApplyDiscount
        "
        v-model="applyDiscount"
        class="md-primary apply-discount md-small-size-100 md-xsmall-size-100"
        >{{ L('includingRi') }}</md-checkbox
      >
      <md-menu
        v-if="showCreditFilter && $config.feature.creditKind"
        md-align-trigger
        md-size="small"
        :mdCloseOnSelect="false"
      >
        <md-button md-menu-trigger>{{ L('credit') }}</md-button>
        <md-menu-content>
          <md-menu-item v-for="filter in creditFilter.filters" :key="filter.id">
            <md-checkbox
              v-model="filtersEnabled"
              :value="filter.id"
              class="md-primary md-small-size-100 md-xsmall-size-100"
            >
              <span @click.stop="nop">{{ L(filter.id) }}</span>
            </md-checkbox>
          </md-menu-item>
        </md-menu-content>
      </md-menu>

      <md-menu
        v-if="selectProject && $config.feature.project"
        md-align-trigger
        md-size="small"
      >
        <md-button md-menu-trigger :disabled="project.list.length === 0">
          {{ getProjectName(curProject) }}
        </md-button>
        <md-menu-content class="md-menu-content-big">
          <search-field
            v-model="searchProject"
            :fields="searchFields"
            :customValue="placeholder"
            class="md-layout-item md-size-90"
            style="margin: 4px 16px"
          />
          <md-menu-item
            v-for="project in searchedProject"
            :key="project.id"
            @click="changeProject(project)"
            class="account-item"
          >
            <span>{{ getProjectName(project) }}</span>
          </md-menu-item>
        </md-menu-content>
      </md-menu>

      <md-menu
        v-if="selectMonth"
        md-align-trigger
        md-size="small"
        class="sub-toolbar-last-menu"
      >
        <md-button class="account-btn" md-menu-trigger>
          {{ L('month') }}: {{ curMonth }}
          <fa-icon icon="caret-down" />
        </md-button>
        <md-menu-content>
          <md-menu-item
            v-for="month in months"
            :key="month"
            class="account-item"
            @click="changeMonth(month)"
            >{{ month }}</md-menu-item
          >
        </md-menu-content>
      </md-menu>
    </div>
  </md-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import api from '@/api'
import { getDate } from '@/lib/utils'
import SearchField from '@/views/layout/SearchField'

export default {
  components: {
    SearchField,
  },

  props: {
    selectProject: Boolean,
    selectMonth: Boolean,
    project: [Object, Object],
    currencyArray: Array,
    showCreditFilter: Boolean,
    showApplyDiscount: Boolean,
  },

  data: () => ({
    langKey: 'menu',
    userSetting: {},
    searchProject: '',
    searchFields: {
      project_name: 'project',
    },
  }),

  mounted() {
    this.load()
  },

  watch: {
    userInfo() {
      this.load()
    },
  },

  computed: {
    ...mapState({
      curMonth: (state) => state.curMonth,
      curProject: (state) => state.curProject,
      creditFilter: (state) => state.creditFilter,
      userInfo: (state) => state.userInfo,
    }),

    months() {
      const months = getDate('oneMonth')
      return months
    },

    applyDiscount: {
      get() {
        return this.creditFilter.applyDiscount
      },
      set(val) {
        this.setUserSetting('applyDiscount', val)
        this.$store.commit('creditFilter/applyDiscount', val)
      },
    },

    filtersEnabled: {
      get() {
        return this.creditFilter.enabled.map((v) => v)
      },
      set(val) {
        this.setUserSetting('credits', val)
        this.$store.commit('creditFilter/enabled', val)
      },
    },

    showProjectId() {
      return this.$config.feature.showProjectId
    },

    projects() {
      return this.project.all
        ? [{ id: '__total' }, ...this.project.list]
        : this.project.list
    },

    searchedProject() {
      return this.projects.filter((project) =>
        this.getProjectName(project)
          .toLowerCase()
          .includes(this.searchProject.trim().toLowerCase())
      )
    },

    placeholder() {
      const labels = this.showProjectId
        ? `${this.L('projectName')}, ${this.L('projectId')}`
        : `${this.L('projectName')}`
      return `${this.L('searchBy')} ${labels}`
    },
  },

  methods: {
    async load() {
      if (!this.userInfo.seq) return

      const userSeq = this.userInfo.seq
      const userSetting = await api.userSetting.get(
        userSeq,
        'global.user',
        'custom'
      )

      if (userSetting) {
        const credits =
          userSetting.data.credits ||
          this.creditFilter.filters.map((credit) => credit.id)
        const creditData = this.$config.feature.creditKind ? credits : null
        const applyDiscount =
          userSetting.data.applyDiscount === undefined
            ? true
            : userSetting.data.applyDiscount
        this.userSetting = {
          ...userSetting.data,
          credits: creditData,
          applyDiscount,
        }
      }

      this.$store.commit('creditFilter/enabled', this.userSetting.credits)
      this.$store.commit(
        'creditFilter/applyDiscount',
        this.userSetting.applyDiscount
      )
    },

    async setUserSetting(type, value) {
      this.userSetting = { ...this.userSetting, [type]: value }

      await api.userSetting.modify(
        this.userInfo.seq,
        'global.user',
        'custom',
        this.userSetting
      )

      const { currency, applyDiscount, enabled, language, appearance } =
        this.userSetting

      const settingInfo = {
        currency,
        applyDiscount,
        enabled,
        language,
        appearance,
      }

      localStorage.setItem('settingInfo', JSON.stringify(settingInfo))
    },

    changeMonth(month) {
      this.$store.commit('curMonth', month)
      this.$store.commit(
        'preMonth',
        moment(month).subtract(1, 'months').format('YYYY-MM')
      )
    },

    changeProject(project) {
      this.$store.commit('curProject', project)
    },

    getProjectName(project) {
      if (project.id === '__total') {
        return this.C('allProjects')
      }
      if (project.id === '__account') {
        return `(${this.L('account')})`
      }
      return this.showProjectId
        ? `${project.name} (${project.id})`
        : project.name
    },
  },
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 800px) {
  .md-toolbar-section-start {
    position: relative;
    top: 1.5px;
  }
}

.apply-discount {
  font-weight: 500;
}
</style>
